module.exports = __webpack_public_path__ + "static/media/iyzico-banner.e091a3cd.png";